module.exports = __webpack_public_path__ + "static/media/9DESA1.6e38c7f3.jpg";